<header>
    <div>
        <app-logo />
    </div>

    @if (sm$ | async) {
        <div class="ml-auto">
            <app-language-switch />
        </div>

        <div>
            <app-user-actions />
        </div>

        <div>
            <app-logout />
        </div>
    } @else {
        <div class="ml-auto">
            <app-mobile-menu-button />
        </div>
    }
</header>
